import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "../index.css";
import gfg from "../Assets/gfg.png";
import gssoc from "../Assets/gssoc.png";
import nasa from "../Assets/nasa.png";
import usEPA from "../Assets/usepa.png";
import icci from "../Assets/icci.png";
import indianrailways from "../Assets/indianrailways.png";
import apple from "../Assets/apple.png";
const Jumbotron = () => {
  return (
    <section className="relative bg-black h-fit bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern.svg')] dark:bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern-dark.svg')] bg-cover bg-center">
      <div className="absolute inset-0 top-0 bg-gradient-to-t from-gray-900 via-gray-900/70 to-transparent"></div>
      <div className="relative py-16 px-6 mx-auto max-w-screen-xl text-center z-10">
        <a
          href="#"
          className="inline-flex items-center py-1 px-3 mb-8 text-sm text-blue-950 bg-blue-100 rounded-full dark:bg-blue-950 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-800"
        >
          <span className="text-xs bg-blue-600 rounded-full text-white px-4 py-1.5 me-4">
            New
          </span>
          <span className="text-sm font-medium">Hall of fame - NASA</span>
          <FontAwesomeIcon
            icon={faArrowRight}
            className="w-4 h-4 ms-3 rtl:rotate-180"
          />
        </a>
        <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-white md:text-5xl lg:text-6xl">
          We invest in the world's potential
        </h1>
        <p className="mb-8 text-lg font-normal text-gray-300 lg:text-xl sm:px-16 lg:px-48">
          A tech association empowering the future with Fullstack, AR/VR,
          Cybersecurity, IoT, Blockchain, and AI domains.
        </p>
        <section
          id="achievements"
          className="bg-transparent py-16 px-6 text-center"
        >
          <h2 className="text-3xl font-bold text-white mb-8">
            Our Achievements
          </h2>
          <div className="overflow-hidden w-full relative">
            <div className="marquee flex items-center w-full">
              <div className="flex justify-around animate-marquee">
                <img
                  src={gfg}
                  alt="Geeks for Geeks Campus Ambassador"
                  className="w-fit h-24 mx-8"
                />
                <img
                  src={nasa}
                  alt="NASA Bug VDP"
                  className="w-fit h-24 mx-8"
                />
                <img src={gssoc} alt="GSSOC'24" className="w-fit h-24 mx-8" />
                <img src={usEPA} alt="US EPA" className="w-fit h-24 mx-8" />
                <img src={icci} alt="ICCI" className="w-fit h-24 mx-8" />
                <img
                  src={indianrailways}
                  alt="GSSOC'24"
                  className="w-fit h-24 mx-8"
                />
                <img src={apple} alt="GSSOC'24" className="w-fit h-24 mx-8" />
                <img
                  src="https://cdn-images-1.medium.com/max/1200/1*ZfYWXN0zA6TqQQ7wGNJUOg.jpeg"
                  alt="GSSOC'24"
                  className="w-24 h-24 mx-8"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <section
        id="works"
        className="relative bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern.svg')] dark:bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern-dark.svg')] bg-cover bg-center py-16 sm:py-20 lg:py-24"
      >
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
      </section>
    </section>
  );
};

export default Jumbotron;
